var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRehamDivaProgram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137.352,
    height: 203.647,
    viewBox: "0 0 137.352 203.647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2521",
    "data-name": "Group 2521",
    transform: "translate(14497.881 15534.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(-14484.301 -15341.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M-2.407-6.26A3.825,3.825,0,0,0,1.585-10.3a3.8,3.8,0,0,0-3.992-4.055H-4.668V-6.26Zm-3.556-9.248h3.556A5.061,5.061,0,0,1,2.927-10.3,5.041,5.041,0,0,1-2.407-5.106H-5.963Z",
    transform: "translate(5.963 15.508)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "M133.969-71.076h1.294v10.4h-1.294Z",
    transform: "translate(-14607.357 -15269.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g28",
    transform: "translate(-14470.738 -15341.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "M0,0H1.482L4.991,8.983,8.5,0H9.981L5.786,10.4H4.18Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g32",
    transform: "translate(-14461.322 -15341.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "M-1.848-4.7H2.659L.414-10.483Zm4.9,1.154H-2.222l-.92,2.308H-4.577l4.18-10.4H1.209l4.2,10.4H3.969Z",
    transform: "translate(4.577 11.637)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g36",
    transform: "translate(-14445.967 -15341.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "M-2.724-.781h-2.73V3.18h2.73A1.933,1.933,0,0,0-.65,1.2,1.933,1.933,0,0,0-2.724-.781M-6.748-1.935h4.18A3.045,3.045,0,0,1,.692,1.2a3.064,3.064,0,0,1-3.26,3.135H-5.454V8.467H-6.748Z",
    transform: "translate(6.748 1.935)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g40",
    transform: "translate(-14436.815 -15341.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M-2.724-.781h-2.73V3.2h2.73A1.945,1.945,0,0,0-.65,1.2,1.933,1.933,0,0,0-2.724-.781m-.655,5.116H-5.454V8.467H-6.748v-10.4h4.18A3.03,3.03,0,0,1,.692,1.2a2.875,2.875,0,0,1-2.7,3.025L.8,8.467H-.728Z",
    transform: "translate(6.748 1.935)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g44",
    transform: "translate(-14427.759 -15341.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M-3.495-.781c-2.339,0-3.82,1.794-3.82,4.227,0,2.417,1.481,4.226,3.82,4.226,2.323,0,3.82-1.809,3.82-4.226,0-2.433-1.5-4.227-3.82-4.227m0-1.154a5.08,5.08,0,0,1,5.163,5.38,5.081,5.081,0,0,1-5.163,5.38,5.073,5.073,0,0,1-5.163-5.38,5.072,5.072,0,0,1,5.163-5.38",
    transform: "translate(8.657 1.935)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g48",
    transform: "translate(-14415.832 -15341.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "M-3.621,0A4.96,4.96,0,0,1,.419,1.95l-1.03.639a3.835,3.835,0,0,0-3.01-1.435A4,4,0,0,0-7.629,5.38,4.018,4.018,0,0,0-3.621,9.622,4.1,4.1,0,0,0-.83,8.5V6.378H-4.4V5.224H.465V8.983a5.419,5.419,0,0,1-4.086,1.793,5.216,5.216,0,0,1-5.349-5.4A5.2,5.2,0,0,1-3.621,0",
    transform: "translate(8.971)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g52",
    transform: "translate(-14404.296 -15341.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "M-2.724-.781h-2.73V3.2h2.73A1.945,1.945,0,0,0-.65,1.2,1.933,1.933,0,0,0-2.724-.781m-.655,5.116H-5.454V8.467H-6.748v-10.4h4.18A3.03,3.03,0,0,1,.692,1.2a2.875,2.875,0,0,1-2.7,3.025L.8,8.467H-.728Z",
    transform: "translate(6.748 1.935)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g56",
    transform: "translate(-14395.894 -15341.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "M-1.848-4.7H2.659L.414-10.483Zm4.9,1.154H-2.222l-.92,2.308H-4.577l4.18-10.4H1.209l4.2,10.4H3.969Z",
    transform: "translate(4.577 11.637)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g60",
    transform: "translate(-14384.56 -15341.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path62",
    d: "M-6.018-1.182-9.559,7.473h-.53l-3.525-8.655V7.473h-1.294v-10.4h1.856l3.229,7.922,3.244-7.922h1.856v10.4H-6.018Z",
    transform: "translate(14.908 2.928)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g64",
    transform: "translate(-14496.906 -15384.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path66",
    d: "M-9.5-10.118a5.393,5.393,0,0,1-.675,2.026,3.246,3.246,0,0,1-1.439,1.263,6.02,6.02,0,0,1-2.525.44h-3.406V-19.426h3.112a7.072,7.072,0,0,1,2.643.411,3.331,3.331,0,0,1,1.557,1.263A5.046,5.046,0,0,1-9.5-15.7a19.462,19.462,0,0,1,.176,2.79A19.451,19.451,0,0,1-9.5-10.118M-4.48-6.535A15.519,15.519,0,0,0-3.335-12.79q0-12.274-10.571-12.274h-9.631v35.3h5.99V-1.1h3.582l3.543,11.337h6.174L-8.5-2.336a8.854,8.854,0,0,0,4.022-4.2",
    transform: "translate(23.537 25.064)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g68",
    transform: "translate(-14468.775 -15384.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path70",
    d: "M0-20.26v5.369H17.853V-20.26H5.99v-6.378H16.327v-5.638H5.99V-44.55H17.853v-5.638H0Z",
    transform: "translate(0 50.188)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g72",
    transform: "translate(-14443.935 -15384.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path74",
    d: "M-9.064-12.125h-7.4V-30.037h-5.99V5.26h5.99v-12.1h7.4V5.26h5.99v-35.3h-5.99Z",
    transform: "translate(22.455 30.037)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g76",
    transform: "translate(-14417.05 -15384.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path78",
    d: "M-4.978-18.406l2.936-15.151h.118L1.012-18.406ZM-4.449-45.6l-7.883,35.3H-6.52l.484-2.469H2.128L2.612-10.3H8.425L.542-45.6Z",
    transform: "translate(12.332 45.597)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g80",
    transform: "translate(-14388.79 -15384.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path82",
    d: "M-14.351,0l-7.635,22.14H-22.1L-29.8,0h-5.755V35.3h5.99V16.385h.118l5.873,17.97h3l5.931-17.97h.117V35.3h5.99V0Z",
    transform: "translate(35.552)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g84",
    transform: "translate(-14469.074 -15477.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path86",
    d: "M-5.864-26.232c-4.707-11.463-5.6-26.3-5.226-38.751A6.3,6.3,0,0,1-14.5-63.136q-.016.793-.023,1.6c-.123,13.457,1.352,24.661,4.4,33.508a7.264,7.264,0,0,1,4.259,1.8",
    transform: "translate(14.527 64.984)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g88",
    transform: "translate(-14456.025 -15446.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path90",
    d: "M-32.614-1.631a14.356,14.356,0,0,1-1.158-2.3q-.2-.05-.4-.11a44.691,44.691,0,0,1-6.551,12.8c-8.254,11.042-19.129,13.088-20.4,13.292a24.759,24.759,0,0,1-18.9-9.539c-.262-.33-.517-.669-.767-1.013a17.277,17.277,0,0,1,.346,5.56,28.009,28.009,0,0,0,19.327,8.329l.141.007.139-.017c.531-.065,13.11-1.742,22.727-14.545A46.974,46.974,0,0,0-31.784-.836a2.141,2.141,0,0,1-.83-.8",
    transform: "translate(80.792 4.041)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g92",
    transform: "translate(-14497.881 -15534.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path94",
    d: "M-82.619-74.914a13.291,13.291,0,0,0-4.356,6.075,20.645,20.645,0,0,1-5.151,8.283c-4.7,4.492-10.84,7.168-15.932,11.186a34.511,34.511,0,0,1-14.006-5.959c4.873-2.348,10.456-3.606,14.144-7.825,1.854-2.122,3.06-5.009,5.258-6.793,2.873-2.333,6.37-.563,9.54-.188a5.358,5.358,0,0,0,5.27-3.091c1.1-2.084.239-4.809-.5-6.852a72.764,72.764,0,0,0-3.477-7.239C-93.6-90.93-93.379-94.6-93.088-98.494a25.082,25.082,0,0,0-1.663-10.386,44.976,44.976,0,0,1-1.961-9.534,68.418,68.418,0,0,0,7.458,5.972c.873.667,1.99,1.473,3.075,2.385a33.8,33.8,0,0,1,2.718,3.142c-.5,5.282-1.92,10.254.475,15.547,2.641,5.835,6.715,11.445.367,16.455m-28.562-80.972c-4.454-3.657-10.3-5.276-15.924-5.973-7.8-.965-15.66-.747-23.467-1.72-6.776-.845-13.89-1.842-20.61-.413a21.879,21.879,0,0,1,5.534-4.651c3.626-2.071,8.027-2.144,12.076-2.334,4.9-.231,9.808-.126,14.713-.218.9-.017,1.8-.083,2.695-.182,3.669.633,7.177,2.3,10.527,3.828,6.225,2.842,12.311,4.9,17.518,9.319a16.623,16.623,0,0,0,2.092,1.963,34.675,34.675,0,0,1,7.833,12.225c.584,6.705.723,14.777.708,19.761-1.115-5.431-3.587-10.475-5.223-15.791-1.8-5.846-3.583-11.8-8.472-15.814M-173.067-77.76c2.782,9.082-4.672,16.767-13.566,16.653a30.075,30.075,0,0,1-3.875-1.876c6.029-2.114,8.042-12.845,4.817-17.776-1.3-1.989-3.469-3.365-4.468-5.543-1.189-2.594-.946-6.15-.853-8.925a16.688,16.688,0,0,1,2.279-8.439c1.037-1.726,2.228-3.3,3.207-5a28.158,28.158,0,0,0,.968,6.214c2.4,8.884,8.82,15.975,11.492,24.694m-13.685-68.055c-.033-5.5,1.056-11.188,3.5-14.371a5.535,5.535,0,0,1,3.953-2.373c-.614,3.223-.752,6.46-2.142,9.509a27.416,27.416,0,0,1-5.309,7.235m45.988-2.119c1.166.01,2.329-.011,3.494-.037a6.67,6.67,0,0,1,2.218.189,14.132,14.132,0,0,1,2.3,1.146c2.159,1.176,4.337,2.316,6.419,3.627a63.4,63.4,0,0,1,9.718,7.307c2.87,2.7,5.551,5.806,6.934,9.557a11.936,11.936,0,0,1-.434,9.77l-.006.683a3.657,3.657,0,0,0-.4-.378c-.662-4.559-3.695-7.918-6.494-11.532-2.958-3.82-3.7-8.81-7.49-12.037-3.706-3.155-9.25-3.863-13.719-5.3-3.393-1.093-6.782-2.26-10.226-3.1,2.563.056,5.126.087,7.689.111M-199.7-72.45a20.928,20.928,0,0,1-1.571-9.822,30.081,30.081,0,0,1,.853-5.182,29.422,29.422,0,0,1,2.531-6.445,41.365,41.365,0,0,0,1.237,7.1c1.142,5.271.29,10.3-3.05,14.349M-67.861-89.71c-2.006-10.444-9.295-19.131-15.056-24.577a79.238,79.238,0,0,0-11.241-8.857c.045-5.268.035-26.427-2.916-32.692-.566-1.546-7.254-18.993-22.41-24.981-15.388-6.079-36.489-8.061-49.554,4.614-3.706,3.595-6.041,7.17-7,10.682a8.808,8.808,0,0,0-9.865,3.308c-5.711,7.444-5.2,25.039-.541,31.348,4.069,5.514-1.808,19.24-4.7,24.628-7.043,3.9-12.787,13.983-13.453,23.739a26.8,26.8,0,0,0,.151,5.468,23.518,23.518,0,0,0,3.1,8.624,22.3,22.3,0,0,0,6.893,6.914c1,.663,2.027,1.288,3.084,1.851a28.858,28.858,0,0,0,12.349,3.512q.378.014.755.016a26.252,26.252,0,0,0,8.594-1.58,12.907,12.907,0,0,0,3.931-1.954,8.933,8.933,0,0,0,1.8-2.052,25.288,25.288,0,0,0,4.107-8.945,18.91,18.91,0,0,0-.527-8.8,32.209,32.209,0,0,0-3.151-7.308,37.412,37.412,0,0,0-3.43-4.969,24.991,24.991,0,0,0-1.705-1.872l-.235-.235-.325-.12c-1.837-.868-8.178-12.066-8.7-21.9-.267-4.988,1.047-8.4,3.9-10.145,7.009-4.278,10.892-13.887,12.942-21.4,5.083,2.571,11.68,2.2,15.551,6.532,3.81,4.268,8.174,5.755,13.573,7.157.159.041.314.085.47.129,3.547,3.348,4.329,8.162,6.985,12.326a12.436,12.436,0,0,0,1.822,2.163c.262.478.536.948.8,1.411q.216.37.437.736a20.991,20.991,0,0,0,1.87,3.411,15.216,15.216,0,0,1,2.92,6.874,36.983,36.983,0,0,1-.359,7.565c-.18,1.882-.293,3.758-.479,5.622a.456.456,0,0,0-.535.27c-4.088,8.749-8.093,17.112-18.146,19.873-1.172.322,1.105,2.431,1.969,2.531,7.2,4.166,14.939-6.492,18.565-11.359q.6-.806,1.188-1.628a.335.335,0,0,0,.072-.1,45.6,45.6,0,0,0,5.312-9.218c2.539-6.249,1.645-13.074-.023-19.442,1.813-4.513,3.789-11.287,2.506-14.764-.09-.245-.2-.486-.3-.727A25.347,25.347,0,0,0-110.4-133.9a41.314,41.314,0,0,0-5.007-5.213,63.022,63.022,0,0,0-5.664-4.427q-1-.708-2.041-1.369c-2.48-1.593-5.02-3.127-7.589-4.573a13.1,13.1,0,0,0-4.336-1.621,29.231,29.231,0,0,0-5.2-.182q-1.411.025-2.823.018c-3.157-.014-6.314-.122-9.469-.235-2.342-.084-4.685-.2-7.022-.372-1.108-.083-2.219-.176-3.326-.295a30.054,30.054,0,0,1,8.116-3.564c6.066-1.556,12.587-.056,18.547,1.263a34.653,34.653,0,0,0,8.409,1.019,25.34,25.34,0,0,1,2.862,1.055,31.072,31.072,0,0,1,9.774,6.977c11.876,12.32,13.838,32.512,10.032,48.45-3.493,14.632-13.235,27.758-28.3,31.355a63.025,63.025,0,0,1-4.8-6.117l-2.789,1.826c.625.956,15.539,23.4,35.771,24.163.35.013.7.019,1.045.019,10.414,0,20.213-5.889,29.137-17.518,6.522-8.5,8.947-17.4,7.206-26.466",
    transform: "translate(204.666 185.579)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g96",
    transform: "translate(-14458.515 -15475.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path98",
    d: "M-12.732-22.405l-.611-17.545a11.929,11.929,0,0,0-3.874-8.99c-5.222-4.555-13.956-3.724-14.043-3.715l-.281-2.765c.406-.041,10.03-.953,16.15,4.386,3.04,2.651,4.663,6.347,4.825,10.987l.5,14.5a6.811,6.811,0,0,1,1.778.162l-.673,2.695a7.021,7.021,0,0,0-2.213.022Z",
    transform: "translate(31.541 55.504)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g100",
    transform: "translate(-14451.506 -15440.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path102",
    d: "M-3.376-3.068C-.779-.42,1.88.919,4.548.919c3.407,0,6.166-2.2,7.586-3.607L9.028-4.559,4.145-2.923.327-4.044ZM4.548,3.7C.5,3.7-3.383,1.459-6.995-2.954L-8.364-4.626l8.732-2.3L4.09-5.835,9.363-7.6l6.955,4.19L15.4-2.181C15.223-1.94,10.951,3.7,4.548,3.7",
    transform: "translate(8.364 7.6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g104",
    transform: "translate(-14468.717 -15467.188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path106",
    d: "M-5.974-2.233C-2.168-1.2,3.128.076,5.91.076l.2,0L5.98-.064a10.092,10.092,0,0,0-7.464-2.69,21.227,21.227,0,0,0-4.489.521M5.91,2.854c-5.044,0-16.651-3.55-17.142-3.7l-3.566-1.1,3.414-1.5a27.458,27.458,0,0,1,9.9-2.086c3.948,0,7.123,1.182,9.435,3.511.517.521,1.891,1.9,1.273,3.388S6.647,2.854,5.91,2.854",
    transform: "translate(14.799 5.532)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g108",
    transform: "translate(-14453.987 -15437.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path110",
    d: "M0,0,.332.092l.923.243c.4.092.876.214,1.426.333s1.17.239,1.837.374c.332.074.686.122,1.046.185s.726.147,1.115.186c.769.107,1.569.239,2.407.317.419.036.836.116,1.267.14s.866.061,1.3.1.879.054,1.322.077l1.333.065,2.665.033c.879-.044,1.747-.059,2.592-.067.84-.067,1.658-.114,2.439-.148.394,0,.768-.057,1.135-.089l1.067-.092C24.9,1.7,25.539,1.681,26.1,1.6c.561-.065,1.059-.1,1.469-.136.823-.066,1.31-.072,1.31-.072s-.4.253-1.14.64c-.369.192-.818.431-1.344.681a15.538,15.538,0,0,1-1.808.728c-.677.226-1.4.517-2.2.707s-1.646.386-2.528.563c-.891.12-1.815.238-2.758.328-.946.042-1.911.063-2.874.056-.962-.08-1.929-.091-2.868-.25a23.108,23.108,0,0,1-2.738-.522,22.84,22.84,0,0,1-2.5-.746c-.778-.285-1.5-.592-2.148-.9-.322-.167-.631-.318-.919-.475s-.552-.33-.8-.479A13.969,13.969,0,0,1,1,.865,8.828,8.828,0,0,1,0,0",
    transform: "translate(0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g112",
    transform: "translate(-14456.221 -15465.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path114",
    d: "M-3.26-1.63A2.408,2.408,0,0,1-5.667.778,2.408,2.408,0,0,1-8.075-1.63,2.408,2.408,0,0,1-5.667-4.037,2.408,2.408,0,0,1-3.26-1.63",
    transform: "translate(8.075 4.037)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRehamDivaProgram);
export default __webpack_public_path__ + "static/media/reham-diva-program.d185921f5f9cb16d30539cf52ce48097.svg";
export { ForwardRef as ReactComponent };